import { createSingleEntityStore } from '@recruitee/ngrx';

import { MessagesCounters } from './messages-counters-http-client';

const { actions, reducer, namespace, selectors } = createSingleEntityStore<MessagesCounters>()(
  'MessagesCounters',
  {
    customActions: adapter => ({
      fetch: (state, payload: { id: number }) => adapter.markAsPending(state),
    }),
  },
);

export {
  actions as MessagesCountersActions,
  reducer as MessagesCountersReducer,
  selectors as MessagesCountersSelectors,
  namespace as MessagesCountersNamespace,
};
